import { withTimeout } from './withTimeout';
/**
 * Wait for an event to be emitted on emitter within timeout.
 *
 * @param emitter emitter of event
 * @param eventName event to wait for
 * @param timeout amount of time in milliseconds to wait for
 * @param predicate function that gets passed the event arguments, should return true if event accepted
 * @param abortSignal
 * @returns {Promise<Parameters<TEvents[TEventName]>>} resolves with event arguments if event occurred within timeout else rejects
 */
export async function waitForEvent(emitter, eventName, timeout = 5000, predicate = () => true, abortSignal) {
    let listener;
    const task = new Promise((resolve) => {
        listener = ((...eventArgs) => {
            if (predicate(...eventArgs)) {
                resolve(eventArgs);
            }
        });
        emitter.on(eventName, listener);
    });
    return withTimeout(task, timeout, 'waitForEvent', abortSignal).finally(() => {
        emitter.off(eventName, listener);
    });
}
//# sourceMappingURL=waitForEvent.js.map